//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { checkCode } from './api'
import store from './store'
export default {
  name: 'app'
  // data() {
  //   return {
  //     isShow: '',
  //     isiOS: false
  //   }
  // },
  // created() {
  //   this.isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  // },
  // watch: {
  //   $route: {
  //     handler(to, from) {
  //       if (to.path === '/') {
  //         this.isShow = false
  //       } else {
  //         this.isShow = true
  //       }
  //     },
  //     immediate: true
  //   }
  // }
}



// WEBPACK FOOTER //
// ./src/App.vue